import { render, staticRenderFns } from "./MarketplaceFeatured.vue?vue&type=template&id=4d52dd48&scoped=true&"
import script from "./MarketplaceFeatured.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFeatured.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceFeatured.vue?vue&type=style&index=0&id=4d52dd48&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52dd48",
  null
  
)

export default component.exports